// src/components/RefundPolicy.tsx
import React from "react";
import { Box, Heading, Text, VStack, UnorderedList, ListItem, Link } from "@chakra-ui/react";
import { companyConfig } from "../config/company";

const RefundPolicy: React.FC = () => {
  const { operatorDescription, supportEmail, website, effectiveDate } = companyConfig;

  return (
    <Box maxW="860px" mx="auto" px={6} py={10}>
      <VStack align="start" spacing={6}>

        <Heading size="xl">Refund Policy</Heading>
        <Text fontSize="sm" color="gray.500">Effective date: {effectiveDate}</Text>

        <Text>
          This Refund Policy applies to purchases made through the {operatorDescription}
          platform. Our policy operates alongside and does not exclude your rights under
          the Australian Consumer Law (ACL).
        </Text>

        <Heading size="md">1. Your Rights Under Australian Consumer Law</Heading>
        <Text>
          Under the ACL, you are entitled to a remedy if a product or service has a
          major failure, is not of acceptable quality, or does not match its description.
          Nothing in this policy limits those statutory rights.
        </Text>

        <Heading size="md">2. Digital Access Products</Heading>
        <Text>
          Because our products provide immediate access to digital content upon purchase,
          we generally do not offer change-of-mind refunds once access has been activated.
          This is consistent with standard practice for digital goods under Australian law.
        </Text>

        <Heading size="md">3. When We Will Issue a Refund</Heading>
        <Text>We will issue a full refund where:</Text>
        <UnorderedList spacing={2} pl={4}>
          <ListItem>The platform was materially unavailable for a significant portion of your access period due to a fault on our side.</ListItem>
          <ListItem>Content purchased was materially different from what was described at the time of purchase.</ListItem>
          <ListItem>A duplicate purchase was made in error — please contact us within 7 days.</ListItem>
          <ListItem>A statutory remedy applies under the ACL.</ListItem>
        </UnorderedList>

        <Heading size="md">4. How to Request a Refund</Heading>
        <Text>
          To request a refund, email{" "}
          <Link href={`mailto:${supportEmail}`} color="blue.500">{supportEmail}</Link>{" "}
          with your order reference number, the email address used at purchase, and a
          brief description of the reason for your request. We will respond within
          5 business days.
        </Text>

        <Heading size="md">5. Processing</Heading>
        <Text>
          Approved refunds are processed via your original payment method through Stripe.
          Refunds typically appear within 5–10 business days depending on your bank.
          Where a refund is granted, your access entitlement will be expired.
        </Text>

        <Heading size="md">6. Contact</Heading>
        <Text>
          <Link href={`mailto:${supportEmail}`} color="blue.500">{supportEmail}</Link>
        </Text>

      </VStack>
    </Box>
  );
};

export default RefundPolicy;